const getImageUrl = (path, fallback = "/images/productimgmiss.png") => {
  if (!path || typeof path !== "string") return fallback;

  const trimmed = path.trim();
  if (!trimmed) return fallback;

  return trimmed;
};

export const handleImageError = (e, fallback = "/images/productimgmiss.png") => {
  if (e && e.target) {
    e.target.onerror = null;
    e.target.src = fallback;
  }
};

export default getImageUrl;
